export default "__VITE_ASSET__BbHUJ3Id__"